// extracted by mini-css-extract-plugin
export default {"texto":"auth_texto__dkCt2","destaque":"auth_destaque__B79E5","acoes":"auth_acoes__4sbI7","separador":"auth_separador__rAibZ","provedor":"auth_provedor__ZuhwY"};